module.exports = __webpack_public_path__ + "static/media/unprotected_shield.1099f74f.svg";